// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1dh5X","amount":"Amount_amount__oqMGy","tip":"Amount_tip__1-0tr","tipHeader":"Amount_tipHeader__20fr0","tipsWrap":"Amount_tipsWrap__HniQo"};